import { render } from "./HealthOverviewTabs.vue?vue&type=template&id=5c14230a&ts=true"
import script from "./HealthOverviewTabs.vue?vue&type=script&lang=ts"
export * from "./HealthOverviewTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__